import { EMPTY_STRING } from '../../constants/common'
import { EVENT_NAME_CLICK } from '../../constants/event'
import { isThemeDark } from '../../utils/themeMode'

import {
  WYSIWYG_EDITOR_CONTENT_STYLE_DARK,
  WYSIWYG_EDITOR_CONTENT_STYLE_LIGHT,
  WYSIWYG_EDITOR_SKIN_DARK,
  WYSIWYG_EDITOR_SKIN_LIGHT,
} from './WysiwygEditor.constants'

// Dark sets only color-scheme: Chrome copies authored colors into merged blocks
function getWysiwygEditorThemeContentStyle(theme) {
  return isThemeDark(theme)
    ? WYSIWYG_EDITOR_CONTENT_STYLE_DARK
    : WYSIWYG_EDITOR_CONTENT_STYLE_LIGHT
}

export function addWysiwygEditorBorderValidation(nodes, error) {
  if (error) {
    nodes[0].style.border = '1px solid var(--color-error)'
  } else {
    nodes[0].style.border = EMPTY_STRING
  }
}

export function simulateWysiwygEditorClickEvent() {
  const simulate = new MouseEvent(EVENT_NAME_CLICK, {
    bubbles: true,
    cancelable: true,
    clientX: 100,
    view: window,
  })

  document.body.dispatchEvent(simulate)
}

export function getWysiwygEditorToolbar({
  enableInlineImageAttach = false,
  enableTables = false,
}) {
  const toolbarGroups = [
    ['fontselect', 'fontsizeselect'],
    ['bold', 'italic', 'underline', 'forecolor'],
    ['alignroup'],
    ['numlist', 'bullist'],
    ['link'],
    ['outdent', 'indent'],
    ['blockquote', 'removeformat'],
  ]

  if (enableInlineImageAttach) {
    toolbarGroups.push(['customImageUploading'])
  }

  if (enableTables) {
    toolbarGroups.push(['table'])
  }

  return toolbarGroups.map(group => group.join(' ')).join(' | ')
}

export function getWysiwygEditorContentStyle({
  blocked,
  contentStyles,
  defaultFont,
  theme,
}) {
  const { bodyStyles = EMPTY_STRING, commonStyles = EMPTY_STRING } =
    contentStyles

  return `body {
        font-family: ${defaultFont.name}, ${defaultFont.family};
        font-size: ${defaultFont.size}px;
        ${bodyStyles}
      }
      ${getWysiwygEditorThemeContentStyle(theme)}
      p {
        line-height: 16px;
        margin: 0;
      }

      p img {
        max-width: 100%;
      }
      .mce-content-readonly {
        ${!blocked ? 'opacity: 0.5;' : EMPTY_STRING}
        cursor: not-allowed;
      }
      ${commonStyles}
      `
}

export function getWysiwygEditorTableConfig({ enableTables = false }) {
  return enableTables
    ? {
        contextmenu: 'table',
        table_toolbar:
          'tableprops tabledelete | ' +
          'tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
          'tableinsertcolbefore tableinsertcolafter tabledeletecol | ' +
          'tablemergecells tablesplitcells',
      }
    : {
        contextmenu: false,
      }
}

export function getWysiwygEditorLinkConfig({ keepLinkUrls = false }) {
  return keepLinkUrls
    ? {
        convert_urls: false,
        link_default_protocol: 'https',
      }
    : {
        relative_urls: false,
        remove_script_host: false,
      }
}

export function getWysiwygEditorSkin(theme) {
  return isThemeDark(theme)
    ? WYSIWYG_EDITOR_SKIN_DARK
    : WYSIWYG_EDITOR_SKIN_LIGHT
}
